import { faCircleCheck, faCircleHalfStroke } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type FC, memo } from 'react';

import './styles.css';
import type { Props } from './types';

const LABELS = { all: 'All', some: 'Some', none: 'None' };

const ContractCoverageIndicator: FC<Props> = ({ coverage, title, size = 'default' }) => (
  <span
    className={`inline-flex items-center gap-1.5 ${size === 'large' ? 'text-base' : ''}`}
    title={title}>
    {coverage === 'all' && (
      <FontAwesomeIcon icon={faCircleCheck} className="text-uniform-green-600" />
    )}
    {coverage === 'some' && (
      <FontAwesomeIcon
        icon={faCircleHalfStroke}
        className="text-uniform-gray-700 dark:text-uniform-gray-300"
      />
    )}
    {coverage === 'none' && (
      <span
        className={`inline-block rounded-full border border-uniform-gray-400 ${size === 'large' ? 'h-4 w-4' : 'h-3.5 w-3.5'}`}
      />
    )}
    <span className={coverage === 'none' ? 'text-uniform-gray-500' : ''}>{LABELS[coverage]}</span>
  </span>
);

export default memo(ContractCoverageIndicator);
